import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'site-modules/shared/components/link/link';

import './answer-items.scss';

const processText = str => {
  const words = str?.trim()?.split(' ');
  const lastWord = words?.pop();
  return { start: words?.join(' '), end: ` ${lastWord}` };
};

export function AnswerItems({ answerItems, classNames = '' }) {
  return (
    <ul className={classnames('m-0', classNames)}>
      {answerItems.map((item, answerIndex) => {
        const { start, end } = processText(item.answer);

        return (
          // eslint-disable-next-line react/no-array-index-key
          <li key={answerIndex} className="answer-item">
            {start}
            <span className="text-nowrap">
              <span className="me-0_25">{end}</span>
              <Link
                to={item.sources[0]}
                className="answer-link rounded-16 bg-blue-90 text-blue-30 text-decoration-none d-inline-flex align-items-center justify-content-center"
                data-tracking-id="click_source_link"
                aria-label="answer source link"
              >
                <i className="icon-link size-10" aria-hidden />
              </Link>
            </span>
          </li>
        );
      })}
    </ul>
  );
}

AnswerItems.propTypes = {
  answerItems: PropTypes.arrayOf(
    PropTypes.shape({
      answer: PropTypes.string,
      sources: PropTypes.shape({}),
    })
  ).isRequired,
  classNames: PropTypes.string,
};
